import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { FormattedMessage, MessageDescriptor } from "react-intl";
import * as React from "react";

type Props = {
    icon: IconProp;
    label: MessageDescriptor;
    children: React.ReactNode;
};

const ItemContainer = ({ icon, label, children }: Props) => (
    <table>
        <tbody>
            <tr>
                <td>
                    <FontAwesomeIcon icon={icon} size="2x" style={{ margin: 5 }} />
                </td>
                <td>
                    <Typography variant="h5">
                        <FormattedMessage {...label} />
                    </Typography>
                </td>
            </tr>
            <tr>
                <td />
                <td>{children}</td>
            </tr>
        </tbody>
    </table>
);

export default ItemContainer;
